import { render, staticRenderFns } from "./BlocksTransactionsRow.vue?vue&type=template&id=14156373&scoped=true"
import script from "./BlocksTransactionsRow.vue?vue&type=script&lang=js"
export * from "./BlocksTransactionsRow.vue?vue&type=script&lang=js"
import style0 from "./BlocksTransactionsRow.vue?vue&type=style&index=0&id=14156373&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14156373",
  null
  
)

export default component.exports